import type { CodeGroupMap } from "~/types/common/backend-dto-types"

/**
 * 공통코드 목록 조회
 * @param grpCd 상위코드명
 * @returns
 */

export const useHconRefCommonCode = (grpCd: string, options = {enabled: true}) => {
  
  const fetchBuilder  = useHconFetchBuilder();

  const codeGroupMap = ref<any>({});
  const codeDataList = ref<any>({});
  const isLoading = ref(true);

  const {enabled = true} = options || {}

  // API 호출
  const fetchBuilderResult = async () => {
    
    await fetchBuilder.get<AjaxResult<CodeGroupMap>>(`/api/v1/common/codes/${grpCd}`)
    .build()
    .execute()
    .then((result) => {
      if(result.data) {
        codeGroupMap.value =  result.data
        codeDataList.value = codeGroupMap.value[grpCd]
      }
    })
    .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200' && error.resultCode != undefined) {
        showAlert(error.resultMessage)
      }
    })
    .finally(() => {
      isLoading.value = false;
    })
  }

  onMounted(() => {
    if(enabled) {
      fetchBuilderResult();
    }
  })

  // 팝업
  const {showAlert} = usePopup()

  return {codeDataList, isLoading}

}
